/**
 * Base URL REST user `/v1` — đồng bộ với axios defaults và BaseService.getUrl.
 */
export function resolveUserApiV1Base() {
    if (typeof window !== "undefined" && window.__SOCIAL_API_BASE_V1) {
        return window.__SOCIAL_API_BASE_V1;
    }
    const base = (process.env.VUE_APP_API_BASE_URL || "").replace(/\/$/, "");
    return `${base}/v1`;
}
